import { useCurrentModule } from '../ModuleProvider';
import { getTranslationTags } from './getTranslationTags';
export const useDisclaimerTranslationTags = props => {
  const {
    url,
    isMobile,
    plainText
  } = props || {};
  const module = useCurrentModule();
  const {
    isQuickPayLightbox
  } = module.internals.useContext();
  return getTranslationTags({
    url,
    isMobile,
    plainText: plainText ?? isQuickPayLightbox
  });
};
//# sourceMappingURL=useDisclaimerTranslationTags.js.map